// extracted by mini-css-extract-plugin
export default {"gallery":"Gallery_gallery__mMbQM","gallery__portfolio":"Gallery_gallery__portfolio__qNzl1"};